// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Dhhri","content":"Consent_content__3L5Hu","footer":"Consent_footer__2xncJ"};